import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
//import { DialogModule } from '@qmanage/ui/dialog/dialog.module';
//import { FileUrlPipeModule } from '@qmanage/ui/file-url-pipe/file-url-pipe.module';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { AddDashboardTileComponent } from './containers/add-dashboard-tile.component';
import { AddDashboardTileEffects } from './state/add-dashboard-tile.effects';
import * as fromDashboard from './state/add-dashboard-tile.reducer';
import { AddDashboardTileFormModule } from './views/add-dashboard-tile-form/add-dashboard-tile-form.module';
//import { AddDashboardTileFormModule } from './views/add-dashboard-tile-form/add-dashboard-tile-form.module';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { AddDashboardTileViewComponent } from './views/add-dashboard-tile-view.component';
import { TileCardViewComponent } from './views/tile-card-view/tile-card-view.component';
import { TileTypeIconModule } from './views/tile-card-view/tile-type-icons/tile-type-icon.module';

@NgModule({
   declarations: [AddDashboardTileComponent, AddDashboardTileViewComponent, TileCardViewComponent],
   exports: [AddDashboardTileComponent, TileCardViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      MatButtonModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatTabsModule,
      ReactiveFormsModule,
      ScrollingModule,
      TileTypeIconModule,
      AddDashboardTileFormModule,
      LcsResponsiveTableModule,
      ResizeOnTabChangeDirectiveModule,
      StoreModule.forFeature(fromDashboard.addDashboardTileFeatureKey, fromDashboard.reducer),
      EffectsModule.forFeature([AddDashboardTileEffects]),
   ],
})
export class AddDashboardTileModule {}
